import { Pipe, PipeTransform } from '@angular/core';
import {amountFormatter} from '../../utils';
import { amtFormatTypes, RUPEE_CODE, RUPEE_SYMBOL } from '../global-meta-data';

@Pipe({
  name: 'SmartValuePipe'
})

export class SmartValuePipe implements PipeTransform {
  transform(value: string | number, currency = RUPEE_CODE, currSymbol = ''): string {

    let parsedValue, returnValue, prefix, amtFormat = amtFormatTypes.INDIAN;
    if (currency === RUPEE_CODE) {
      prefix = RUPEE_SYMBOL;
      amtFormat = amtFormatTypes.INDIAN;
    } else {
      prefix = currSymbol;
      amtFormat = amtFormatTypes.WESTERN;
    }
    parsedValue = Number(value);
    if (parsedValue) {
      returnValue = amountFormatter(parsedValue, prefix, null, amtFormat);
    } else {
      returnValue = value;
    }
    return returnValue;
  }
}
